import { component } from 'common/util/ComponentDecorator';
import YandexMapsLoader from 'common/util/YandexMapsLoader';

@component
export default class Map {
	static classname = 'map';

	_placemarks = [];

	constructor($map) {
		this.$map = $map;
		this.params = this.$map.data('params') || [];

		this.init();
	}

	init() {
		YandexMapsLoader().then(this.handleMapsLoad);
	}

	get center_coords() {
		return this.params.center || [];
	}

	get zoom() {
		return this.params.zoom || 7;
	}

	get placemarks() {
		return this.params.placemarks || [];
	}

	get placemark_options() {
		return window.elkitorg_yandex_maps_placemark_options || {};
	}

	handleMapsLoad = () => {
		this.map = new ymaps.Map(this.$map[0], {
			center: this.center_coords,
			zoom: this.zoom
		});

		this.map.behaviors.disable('scrollZoom');

		if (this.placemarks && this.placemarks.length) {
			this.placemarks.forEach(placemark_params => {
				let balloonContent = '';
				if (placemark_params.title) {
					balloonContent += `<strong>${placemark_params.title}</strong>`;
				}
				if (placemark_params.description) {
					if (placemark_params.title) {
						balloonContent += '<br/>';
					}

					balloonContent += placemark_params.description;
				}

				let params = {
					balloonContent
				};
				let options = {};

				if (placemark_params.style && placemark_params.style in this.placemark_options) {
					options = Object.assign(options, this.placemark_options[placemark_params.style]);
				}

				const placemark = new ymaps.Placemark(placemark_params.coords, params, options);
				this.map.geoObjects.add(placemark);

				this._placemarks.push(placemark);
			});
		}

		if (this.params.init_change_center_btns) {
			this.initSetCenterHandlers();
		}
	};

	initSetCenterHandlers = () => {
		const self = this;

		$('.map-address').on('click', function () {
			const itemKey = $(this).data('key');
			const itemPlacemark = self.params.placemarks.find((item) => item.key === itemKey);

			if(itemPlacemark) {
				self.map.setZoom(12);
				self.map.panTo(itemPlacemark.coords, {
					flying: 1
				});
			}
		});
	}
}
